export default {
  dbi_pagination_total: '{total} total items',
};
